import { createSlice } from '@reduxjs/toolkit';

import { handleGetMedicationSearch } from './actions';
import { IMedicationSearchState } from './slice.interface';

const initialState: IMedicationSearchState = {
  data: null,
  isLoading: false,
};

export const medicationSearchSlice = createSlice({
  name: 'medication-search',
  initialState,
  reducers: {
    removeMedicationsSearch: state => {
      state.data = null;
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetMedicationSearch.pending, (state: IMedicationSearchState) => {
        state.isLoading = true;
      })
      .addCase(handleGetMedicationSearch.fulfilled, (state: IMedicationSearchState, action) => {
        const { page, pageCount } = action.payload.data.pagination;

        if (pageCount === 1 || page === 1) {
          state.data = action.payload.data;
        } else {
          state.data = {
            ...action.payload.data,
            tableData: [...(state.data?.tableData ?? []), ...action.payload.data.tableData],
          };
        }

        state.isLoading = false;
      });
  },
});

export const { removeMedicationsSearch } = medicationSearchSlice.actions;

export default medicationSearchSlice.reducer;
